<template>
    <el-card>
        <el-tabs v-model="activeName">
            <el-tab-pane label="平台券管理" name="first">
                <consumer-coupons-manager></consumer-coupons-manager>
            </el-tab-pane>
            <el-tab-pane label="商家接劵审核" name="second">
                <consumer-coupons-apply></consumer-coupons-apply>
            </el-tab-pane>
        </el-tabs>

    </el-card>
</template>
<script>
import ConsumerCouponsManager from '@/pages/vipCard/consumerCouponsManager/children/ConsumerCouponsManager'
import ConsumerCouponsApply from '@/pages/vipCard/consumerCouponsManager/children/ConsumerCouponsApply'
export default {
  components: { ConsumerCouponsApply, ConsumerCouponsManager },
  data () {
    return {
      activeName: 'first'
    }
  },
  created () {
    let params = this.$route.params
    if (params.activeName) {
      this.activeName = params.activeName
    }
  }
}
</script>
